import ErrorDisplay from '../../../../components/ErrorDisplay';
import LessonCard from '../../lessons/LessonCard/LessonCard';
import Loading from '../../../../components/Loading';
import { Slot } from '@opanuj/shared/types';
import { useClients } from '../../../../hooks/useClients';
import { useLessonsList } from '../../../../hooks/useLessons';
// import LessonsList from "../../lessons/LessonsList";

export type SlotLessonsListProps = {
    slot: Slot;
};

function SlotLessonsList({ slot }: SlotLessonsListProps) {
    const [lessons, loadingLessons, lessonsError] = useLessonsList()
    const [clients, loadingClients, clientsError] = useClients()
	
	if (loadingLessons || loadingClients) return <Loading/>
	if (lessonsError || clientsError) return <ErrorDisplay error={lessonsError || clientsError}/>

	const lessonWithClients = lessons!.filter((lesson) => lesson.sourceSlot === slot.id).map((lesson) => {
		return {
			...lesson,
			students: lesson.students.map(({ uid, ...student }) => ({
				...student,
				uid,
				client: clients![uid],
			})),
		};
	});

	// return <LessonsList lessons={lessonWithClients} />;
	return <>
        {(lessonWithClients ?? []).map((lesson) => {
            return ( <LessonCard key={lesson.id} lesson={lesson} /> )
        })}
        </>
}
export default SlotLessonsList;